import React from "react";

interface TypeformProgressProps {
  current: number;
  total: number;
}

export default function TypeformProgress({ current, total }: TypeformProgressProps) {
  const pct = total > 0 ? ((current + 1) / total) * 100 : 0;

  return (
    <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
      <div
        className="h-full bg-pista-700 transition-all duration-500 ease-out rounded-full"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
